<template>
  <Menu buttonText="Register Here" />
  <main id="schedule">
    <dayone />
    <daytwo />
    <daythree />
  </main>
</template>

<script>
import Menu from '@/components/nashville/menu';
import dayone from '@/components/nashville/agenda/dayone.vue';
import daytwo from '@/components/nashville/agenda/daytwo.vue';
import daythree from '@/components/nashville/agenda/daythree.vue';

export default {
  name: 'Schedule',
  components: {
    Menu,
    dayone,
    daytwo,
    daythree
  },
};
</script>
